import { render } from "./AiAnalysis.vue?vue&type=template&id=3fd6160f"
import script from "./AiAnalysis.vue?vue&type=script&lang=js"
export * from "./AiAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__